import { useServices, types } from "@/lib/openapi";

export type LinkPreview = types.PreviewLinkProxyPreviewLinkGetResponse;

const linksAndPreviews: { [key: string]: LinkPreview | undefined } = {};

export const useLinkPreview = () => {
    const api = useServices({
        opts: { throwOnError: false },
        requires: {
            auth: true,
            organization: false,
            stek: false,
        },
    });

    const inCache = (url: string) => {
        return url in linksAndPreviews;
    };

    return {
        get: async (url: string): Promise<LinkPreview | undefined> => {
            if (!inCache(url)) {
                const { response, data } =
                    await api.previewLinkProxyPreviewLinkGet({
                        query: {
                            url,
                        },
                    });
                if (response.ok) {
                    linksAndPreviews[url] = data;
                } else {
                    linksAndPreviews[url] = undefined;
                }
            }
            return linksAndPreviews[url];
        },
        /**
         * Returns value from cache or false if not found in cache.
         */
        getFromCache: (url: string): LinkPreview | undefined | false => {
            if (inCache(url)) {
                return linksAndPreviews[url];
            } else {
                return false;
            }
        },
    };
};
